import { Check, Edit } from "@mui/icons-material";
import { Box, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";

function ParkingDetails({parking}) {

    return (
        <Box>
            <Typography sx={{ fontSize: '18px', fontWeight: 300, textAlign: 'left', fontWeight: 'bold' }}>
                {parking?.name}
            </Typography>
            <Table>
                <TableBody>
                <TableRow>
                        <TableCell>
                            Offer:
                        </TableCell>
                        <TableCell>
                            {parking?.offerId}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Airport:
                        </TableCell>
                        <TableCell>
                            {parking?.airportCode ?? parking?.location}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Description:
                        </TableCell>
                        <TableCell>
                            {parking?.description}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Box>
    );
}

export default ParkingDetails;
